import { Component, OnInit } from '@angular/core';
import { JeevesCustomerContactCardListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'cult-cult-customer-contact-card-list',
    templateUrl: './cult-customer-contact-card-list.component.html',
    styleUrls: ['./cult-customer-contact-card-list.component.scss'],
    standalone: false
})
export class CultCustomerContactCardListComponent extends JeevesCustomerContactCardListComponent implements OnInit {
  ngOnInit() {
    this.phone = this.data.extra.CS1 ? this.data.extra.CS1.comnr || '-' : '-';
    this.mobile = this.data.extra.CS4 ? this.data.extra.CS4.comnr || '-' : '-';
    this.email = this.data.extra.CS3 ? this.data.extra.CS3.comnr || '-' : '-';
  }
}
